import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { slugify } from '../../../../utilities/helpers';
import './NewsModal.scss';

const NewsModal = ({ onClose, onSubmit }) => {
  const categories = [
    { id: 1, name: "Technology", value: "technology" },
    { id: 3, name: "Funding", value: "funding" },
    { id: 4, name: "Careers", value: "careers" },
    { id: 2, name: "Partnerships", value: "partnerships" },
    { id: 5, name: "Media Coverage", value: "media-coverage" },
  ];
  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    metaTitle: '',
    metaDescription: '',
    author: '',
    excerpt: '',
    category: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Auto-generate slug when title changes
    if (name === 'title') {
      setFormData({
        ...formData,
        title: value,
        slug: slugify(value),
        metaTitle: value // Auto-fill meta title with the title
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.title.trim() || !formData.slug.trim()) {
      alert('Title and slug are required.');
      return;
    }
    
    onSubmit(formData);
  };

  return (
    <div className="news-modal-overlay">
      <div className="news-modal">
        <div className="modal-header">
          <h2>Create New News Article</h2>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title">Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
              placeholder="Enter news title"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="slug">URL Slug *</label>
            <input
              type="text"
              id="slug"
              name="slug"
              value={formData.slug}
              onChange={handleChange}
              required
              placeholder="Enter URL slug"
            />
            <small>The URL-friendly version of the title. Auto-generated but can be edited.</small>
          </div>
          
          <div className="form-group">
            <label htmlFor="metaTitle">Meta Title</label>
            <input
              type="text"
              id="metaTitle"
              name="metaTitle"
              value={formData.metaTitle}
              onChange={handleChange}
              placeholder="Enter meta title for SEO"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="metaDescription">Meta Description</label>
            <textarea
              id="metaDescription"
              name="metaDescription"
              value={formData.metaDescription}
              onChange={handleChange}
              placeholder="Enter meta description for SEO"
              rows="3"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="author">Author</label>
            <input
              type="text"
              id="author"
              name="author"
              value={formData.author}
              onChange={handleChange}
              placeholder="Enter author name"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="category">Category</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {categories.map(category => (
                <option key={category.id} value={category.value}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="excerpt">Excerpt</label>
            <textarea
              id="excerpt"
              name="excerpt"
              value={formData.excerpt}
              onChange={handleChange}
              placeholder="Brief excerpt or summary"
              rows="3"
            />
          </div>
          
          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Create News Article
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewsModal; 